// ============================================
// src/utils/apiBase.js
// ============================================
// Single source of truth for the backend API base URL in Signal.
// Signal is a CRA app — uses process.env.REACT_APP_API_URL.
// Audit: grep -rn 'dating-app-backend-production' src/ — count should be 1.
// ============================================

export const API_BASE =
  process.env.REACT_APP_API_URL ||
  'https://dating-app-backend-production-a927.up.railway.app';
